import { InteractiveList } from "@circle-react-shared/InteractiveList";
import classnames from "classnames";
import type { ComponentPropsWithRef } from "react";
import { forwardRef } from "react";

import { legacyClassNames } from "@/react/helpers/cssAnchorHelpers";

import { OptionsDropdownItemContent } from "./OptionsDropdownItemContent";

export interface OptionsDropdownProps extends ComponentPropsWithRef<"div"> {
  direction?: "up" | "down";
  items: any[];
  loading?: boolean;
  notFoundContent?: React.ReactNode | string;
  onSelect: (item: any) => void;
  optionsDropdownClassName?: string;
}

export const OptionsDropdown = forwardRef<HTMLDivElement, OptionsDropdownProps>(
  (
    {
      items,
      onSelect,
      loading,
      notFoundContent,
      direction,
      optionsDropdownClassName,
      ...rest
    }: OptionsDropdownProps,
    ref,
  ) => (
    <div
      ref={ref}
      className={classnames(
        legacyClassNames(`select-list direction-${direction}`),
        "bg-primary",
        optionsDropdownClassName,
      )}
      {...rest}
    >
      <InteractiveList
        subsectionKey=""
        loading={loading || false}
        getKey={item => item.value}
        getItemContent={OptionsDropdownItemContent}
        items={items}
        onSelect={onSelect}
        notFoundContent={notFoundContent as string}
      />
    </div>
  ),
);

OptionsDropdown.displayName = "OptionsDropdown";
